"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toKebabCase = void 0;
var toKebabCase_1 = require("./strings/toKebabCase");
Object.defineProperty(exports, "toKebabCase", { enumerable: true, get: function () { return toKebabCase_1.toKebabCase; } });
